// extracted by mini-css-extract-plugin
export default {"fullWidth":"Km-z","image":"Lm-z","lazyLoadPicture":"Mm-z","lazyLoadSpinner":"Nm-z","lazyLoadSpin":"Om-z","lazyLoadImage":"Pm-z","hasStyledAspectRatio":"Qm-z"};